<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              Edit Password
            </div>

            <div class="subtitle-1 font-weight-light">
              Complete your password
            </div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>
                
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    class="purple-input"
                    label="User Name"
                    v-model="namauser"
                    disabled=""
                    required

                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    label="Email Address"
                    class="purple-input"
                    v-model="email"
                    type="email"
                    required
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    label="Password"
                    class="purple-input"
                     type="password"
                     v-model="pass"
                  />
                  <v-text-field
                    label="Re-Password"
                    class="purple-input"
                     type="password"
                     v-model="repass"
                     required
                  />
                </v-col>                 
                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn
                    color="success"
                    class="mr-0"
                    @click="updateprofile()"
                  >
                    Update Profile
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <base-material-card
          class="v-card-profile"
          avatar="https://demos.creative-tim.com/vue-material-dashboard/img/marc.aba54d65.jpg"
        >
          <v-card-text class="text-center">
            <h6 class="display-1 mb-1 grey--text">
              CEO / CO-FOUNDER
            </h6>

            <h4 class="display-2 font-weight-light mb-3 black--text">
              {{namauser}}
            </h4>

            <p class="font-weight-light grey--text">
              Bali SolutionBiz adalah perusahaan yang bergerak di bidang IT fokus kepada software development dan konsultasi business yang berhubungan dengan IT.
            </p>

            <v-btn
              @click="submitlogout()"
              color="warning"
              rounded
              class="mr-0"
            >
              Logout
            </v-btn>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';

  export default {
    name:'profile',
    data() {
      return{
        datalogout:'',
        namauser:'',
        pass:'',
        email:'',
        repass:'',

      };
    },
    created(){
      this.namauser = this.$cookies.get('user');
      this.email = this.$cookies.get('emailuser');
      

    },
    computed:{
    ...mapState(['API_URL']),
    },

    methods :{
      ...mapActions('serial',['getSerial','resetserialnumber']),
      ...mapActions('login',['updatelogin']),

       alertNotif(title, type, text) {
        this.$swal({
          heightAuto: false,
          title,
          type,
          text,
        });
      },
    

      updateprofile(){
        const param=new FormData();
        param.append('user',this.namauser);
        param.append('email',this.email);
        param.append('pass',this.pass);
        this.updatelogin(param).then((res)=>{
          if (res.success) {
            this.alertNotif("Update Data",'success',res.message);
            this.$router.push('/');

          }else{
            this.alertNotif("Update Data",'warning',res.message);
            this.$router.push('/');
          }
        });

      },

      submitlogout(){
        this.$cookies.remove('user','');
        this.$cookies.remove('statususer','');
        this.$cookies.remove('emailuser','');
        this.$router.push('/login');
      },
    
    },
  
  
  }

  
</script>
